import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';

export class ApiError {
  public constructor(public statusInt: number, public message: string, public errorTypeString: string) {}

  public getUserMessage(): string {
    return this.message;
  }
}

interface ErrorJSON {
  message: string;
  errorType: string;
  data: any;
}

@Injectable()
export class ApiErrorFactory {
  private unknownErrorKey = 'API_ERROR.UNKNOWN';
  private apiErrorNames = {
    DomainConflictException: 'DomainConflictException',
    InvalidDomainException: 'InvalidDomainException',
    InvalidValueException: 'InvalidValueException',
    InvalidValueSubDomainException: 'InvalidValueSubDomainException',
    InvalidValueSubtitleException: 'InvalidValueSubtitleException',
    InvalidValueTitleException: 'InvalidValueTitleException',
    InvalidRequestForDomainStateException: 'InvalidRequestForDomainStateException',
    InvalidRequestForPrimaryDomainException: 'InvalidRequestForPrimaryDomainException',
    MaxNumberDomainsException: 'MaxNumberDomainsException',
    ServiceNotFoundException: 'ServiceNotFoundException',
    SiteNotFoundException: 'SiteNotFoundException',
    SiteReservationConflictException: 'SiteReservationConflictException',
    SuspendedAPIError: 'SuspendedAPIError',
    TemplateIsAlreadyDeletingException: 'TemplateIsAlreadyDeletingException',
    SiteLockedException: 'SiteLockedException',
  };

  constructor(private translate: TranslateService) {}

  public parseErrorResponse(error: HttpErrorResponse): ApiError {
    const errorText = 'error';
    let errorJson: any;
    try {
      errorJson = error[errorText].error;
    } catch {
      errorJson = error;
    }

    const key = this.getMessageKey(errorJson);
    let message = this.translate.instant(key, errorJson);
    if (message === key) {
      message = this.translate.instant(this.unknownErrorKey);
    }
    return new ApiError(error.status, message, errorJson.errorType);
  }

  private getMessageKey(errorJson: ErrorJSON): string {
    const errorName = this.apiErrorNames[errorJson.errorType];
    if (errorName) {
      return 'API_ERROR.' + errorName;
    }
    return this.unknownErrorKey;
  }
}
